import request from "../request";
import { stringify } from "qs";

export function getApplyCaptcha(payload) {
	return request.get({
		url: `/website/reservation/captcha?${stringify(payload)}`,
	});
}

export function verifyApplyCaptcha(payload) {
	return request.get({
		url: `/website/reservation/verifyCaptcha?${stringify(payload)}`,
	});
}

export function getVerificationCode(payload) {
	return request.get({
		url: `/authority/login/getVerificationCode?${stringify(payload)}`,
	});
}

export function register(payload) {
	return request.post({
		url: "/authority/login/register",
		headers: { "Content-Type": "application/x-www-form-urlencoded" },
		data: payload,
	});
}

// 申请演示
export function presentation(payload) {
	return request.post({
		url: "/website/reservation/freeReservation",
		headers: { "Content-Type": "application/json" },
		data: payload,
	});
}
